import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";

import { audioReducer } from "./modules/audio/reducer";
import { displayReducer } from "./modules/display/reducer";
import { libraryReducer } from "./modules/library/reducer";
import { modalReducer } from "./modules/modal/reducer";
import { sessionReducer } from "./modules/session/reducer";

const rootReducer = combineReducers({
  audio: audioReducer,
  display: displayReducer,
  library: libraryReducer,
  modal: modalReducer,
  session: sessionReducer,
  toastr: toastrReducer,
});

export default rootReducer;
export type IRootState = ReturnType<typeof rootReducer>;
